module.exports = __webpack_public_path__ + "static/media/hos_1_filter.331185ed.png";